import {
  RESET_CANCEL_PURORDER,
  CANCEL_PURORDER_NOT_FOUND,
  CANCEL_PURORDER_FAILED,
  CANCEL_PURORDER_INVALID_REQUEST,
  CANCEL_PURORDER_SUCCESS,
  LOADING_CANCEL_PURORDER,
} from "../types";

const initialState = {
  isLoading: false,
  success: false,
  failed: false,
  invalidRequest: false,
  notFound: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_CANCEL_PURORDER:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        invalidRequest: false,
        notFound: false,
      };

    case CANCEL_PURORDER_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        invalidRequest: false,
        notFound: false,
        status: "Cancel order failed!",
      };

    case CANCEL_PURORDER_INVALID_REQUEST:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: true,
        failed: false,
        notFound: false,
        status: "Oops!!, Something went wrong",
      };

    case CANCEL_PURORDER_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        success: true,
        invalidRequest: false,
        failed: false,
        notFound: false,
        status: "Order cancelled successfully!",
      };
    }

    case CANCEL_PURORDER_NOT_FOUND:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: false,
        failed: false,
        notFound: true,
        status: "Order not found!",
      };

    case RESET_CANCEL_PURORDER:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: false,
        failed: false,
        notFound: false,
      };

    default:
      return state;
  }
};
